import { createFileRoute } from '@tanstack/react-router';
import { head } from '@pages/JobsKeepMeInMindPage.head';
import { JobsKeepMeInMindPage } from '@pages/JobsKeepMeInMindPage';

export const Route = createFileRoute('/jobs/keep-me-in-mind')({
  component: JobsKeepMeInMindPage,
  head: () => head,
});
